import { render, staticRenderFns } from "./languageMdeltest.vue?vue&type=template&id=91f0c4bc&scoped=true&"
import script from "./languageMdeltest.vue?vue&type=script&lang=js&"
export * from "./languageMdeltest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f0c4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91f0c4bc')) {
      api.createRecord('91f0c4bc', component.options)
    } else {
      api.reload('91f0c4bc', component.options)
    }
    module.hot.accept("./languageMdeltest.vue?vue&type=template&id=91f0c4bc&scoped=true&", function () {
      api.rerender('91f0c4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/languageMdeltest.vue"
export default component.exports